<div class="container">
    <app-header></app-header>
</div>

<main role="main" class="container">
    <div class="row">
        <div class="col-md-8 blog-main">
            <div class="blog-post">

                <h2 class="blog-post-title">Grußwort Rosch Haschana 5786</h2>
                <h3>Jüdisches Neujahrsfest 2025</h3>
                <img src="assets/img/soeder.jpg" class="rounded float-left" height="360px"
                    style="padding-right: 15px; padding-bottom: 15px" alt="Markus Soeder">
                <p>Den jüdischen Bürgerinnen und Bürgern einen herzlichen Gruß zum Neujahrsfest! Für das neue Jahr alles
                    Gute, Glück und Gesundheit!</p>
                <p>Bayern ist stolz auf seine lebendige jüdische Gemeinschaft. Sie hat feste
                    Wurzeln in Bayern, ist prägender Bestandteil der kulturellen Vielfalt im
                    Freistaat und stellt eine wahre Bereicherung für unsere Gesellschaft dar.
                    Jüdisches Leben gehört untrennbar zu Bayern! Das ist von unschätzbarem
                    Wert und verdient fortlaufend unseren vollen Einsatz. In Zeiten, in denen
                    Extremismus und Antisemitismus immer weitere Kreise ziehen, kommt es
                    noch mehr darauf an, klare Haltung zu zeigen, entschlossen zu handeln
                    und mit ganzer Kraft für das Wohl unserer jüdischen Mitbürgerinnen und
                    Mitbürger einzutreten.</p>
                <p>Dafür steht die Bayerische Staatsregierung! Die jüdischen Gemeinden
                    können auf ihr Schutzversprechen zählen. Sie setzt auf einen konsequenten Rechtsstaat, geht
                    tatkräftig gegen Rassismus und Menschenverachtung im Netz vor und sichert nachdrücklich jüdische
                    Einrichtungen. Zudem
                    steht sie an der Seite Israels und respektiert uneingeschränkt sein Recht
                    auf Selbstverteidigung. Drohungen gegen die Existenz Israels sind nicht
                    hinnehmbar! Wir tun alles dafür, dass sich die Jüdinnen und Juden in Bayern sicher fühlen und mit
                    Zuversicht in die Zukunft schauen können. Genau
                    darum geht es an Rösch Haschana: innehalten, das vergangene Jahr reflektieren - und mit Hoffnung und
                    Optimismus in das neue starten.
                    Shanah Tova!</p>

                <p>Dr. Markus Söder, <br />Ministerpräsident des Freistaats Bayern</p>
            </div><!-- /.blog-post -->

        </div><!-- /.blog-main -->

        <aside class="col-md-4 blog-sidebar">
            <app-info-box></app-info-box>
        </aside><!-- /.blog-sidebar -->
    </div><!-- /.row -->

</main><!-- /.container -->

<app-related-articles></app-related-articles>